import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useLocationList = ({ notTable } = {}) => {
  const [loading, setLoading] = useState(true);
  const [locationList, setLocationList] = useState([]);
  const [pageRef, setpageRef] = useState('');

  const { enqueueSnackbar } = useSnackbar();

  const getLocationList = (params = {}) => {
    setLoading(true);

    axiosClient
      .get('InventoryGeo/Location/List', { params })
      .then(res => {
        if (res.status === 200) {
          setpageRef(res.data.value);
          if (notTable) {
            setLocationList(prev => {
              const orderedList = res.data.value.list.map(element => ({
                key: element.guid,
                value: element.display,
              }));

              return orderedList;
            });
          } else {
            setLocationList(prev => {
              const orderedList = res.data.value.list.map(element => ({
                id: element.guid,
                title: element.display,
              }));

              return { ...prev, [params?.page || 1]: orderedList };
            });
          }
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  return [getLocationList, loading, locationList, pageRef];
};

export default useLocationList;
